var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jurisdictionSet"},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.jurisdiction.catagoryGoods,"show-checkbox":"","node-key":"union_id","highlight-current":"","props":_vm.props},on:{"check":_vm.checkChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }